import styled from 'styled-components';

import Theme from '../../theme';

export default {
  ModalWrapper: styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    top: 0;
    left: 0;
  `,

  Overlay: styled.div`
    background-color: rgba(2, 2, 2, 0.8);
    width: inherit;
    height: inherit;
  `,

  ModalWindow: styled.div`
    ${Theme.media.md`
      width: 80vw;
      height: auto;
      min-height: 250px;
      max-height: 90vh;
      overflow-y: auto;
      max-width: 580px;
      padding: 3.75rem;
    `}

    background-color: ${Theme.colours.white};
    top: 50%;
    left: 50%;
    height: 100vh;
    width: 100vw;
    max-height: 100vh;
    overflow-y: auto;
    transform: translate(-50%, -50%);
    z-index: 99999;
    position: absolute;
    border-radius: 3px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: 3px ${Theme.colours.singtelred} solid;
    padding: 2rem;

    box-sizing: border-box;

    ::-webkit-scrollbar {
      display: none;
    }
  `,

  CloseButton: styled.a`
    width: 16px;
    height: 16px;
    cursor: pointer;
    top: 60px;
    right: 60px;
    position: absolute;
    z-index: 1;
    line-height: 1;
  `
};
